export const UNITS = {
    km:   { cat: 'length', factor: 1000, display: 'km' },
    m:    { cat: 'length', factor: 1, display: 'm' },
    cm:   { cat: 'length', factor: 0.01, display: 'cm' },
    mm:   { cat: 'length', factor: 0.001, display: 'mm' },
    mi:   { cat: 'length', factor: 1609.344, display: 'mil' },
    ft:   { cat: 'length', factor: 0.3048, display: 'ft' },
    in:   { cat: 'length', factor: 0.0254, display: 'inç' },
    yd:   { cat: 'length', factor: 0.9144, display: 'yard' },

    ton:  { cat: 'weight', factor: 1000, display: 'ton' },
    kg:   { cat: 'weight', factor: 1, display: 'kg' },
    g:    { cat: 'weight', factor: 0.001, display: 'g' },
    mg:   { cat: 'weight', factor: 0.000001, display: 'mg' },
    lb:   { cat: 'weight', factor: 0.453592, display: 'lb' },
    oz:   { cat: 'weight', factor: 0.0283495, display: 'oz' },

    l:    { cat: 'volume', factor: 1, display: 'L' },
    ml:   { cat: 'volume', factor: 0.001, display: 'mL' },
    gal:  { cat: 'volume', factor: 3.78541, display: 'gal' },

    c:    { cat: 'temp', display: '°C' },
    f:    { cat: 'temp', display: '°F' },
    k:    { cat: 'temp', display: 'K' },

    byte: { cat: 'data', factor: 1, display: 'B' },
    kb:   { cat: 'data', factor: 1024, display: 'KB' },
    mb:   { cat: 'data', factor: 1048576, display: 'MB' },
    gb:   { cat: 'data', factor: 1073741824, display: 'GB' },
    tb:   { cat: 'data', factor: 1099511627776, display: 'TB' },

    sn:   { cat: 'time', factor: 1, display: 'sn' },
    dk:   { cat: 'time', factor: 60, display: 'dk' },
    saat: { cat: 'time', factor: 3600, display: 'sa' },
    gun:  { cat: 'time', factor: 86400, display: 'gün' },
    hafta:{ cat: 'time', factor: 604800, display: 'hafta' },
}

export const UNIT_ALIASES = {
    'km': 'km', 'kilometre': 'km', 'kilometer': 'km',
    'm': 'm', 'metre': 'm', 'meter': 'm',
    'cm': 'cm', 'santimetre': 'cm', 'santim': 'cm', 'centimeter': 'cm',
    'mm': 'mm', 'milimetre': 'mm', 'millimeter': 'mm',
    'mil': 'mi', 'mile': 'mi', 'mi': 'mi',
    'feet': 'ft', 'foot': 'ft', 'ft': 'ft',
    'inç': 'in', 'inc': 'in', 'inch': 'in',
    'yard': 'yd', 'yarda': 'yd', 'yd': 'yd',

    'ton': 'ton',
    'kg': 'kg', 'kilo': 'kg', 'kilogram': 'kg',
    'g': 'g', 'gr': 'g', 'gram': 'g',
    'mg': 'mg', 'miligram': 'mg', 'milligram': 'mg',
    'lb': 'lb', 'pound': 'lb', 'libre': 'lb',
    'oz': 'oz', 'ons': 'oz', 'ounce': 'oz',

    'l': 'l', 'lt': 'l', 'litre': 'l', 'liter': 'l',
    'ml': 'ml', 'mililitre': 'ml', 'milliliter': 'ml',
    'galon': 'gal', 'gallon': 'gal', 'gal': 'gal',

    '°c': 'c', 'celsius': 'c', 'santigrat': 'c', 'derece': 'c',
    '°f': 'f', 'fahrenheit': 'f', 'fahrenhayt': 'f',
    'kelvin': 'k',

    'byte': 'byte', 'bayt': 'byte',
    'kb': 'kb', 'kilobyte': 'kb', 'kilobayt': 'kb',
    'mb': 'mb', 'megabyte': 'mb', 'megabayt': 'mb',
    'gb': 'gb', 'gigabyte': 'gb', 'gigabayt': 'gb',
    'tb': 'tb', 'terabyte': 'tb', 'terabayt': 'tb',

    'sn': 'sn', 'saniye': 'sn', 'second': 'sn', 'sec': 'sn',
    'dk': 'dk', 'dakika': 'dk', 'minute': 'dk', 'min': 'dk',
    'saat': 'saat', 'sa': 'saat', 'hour': 'saat', 'hr': 'saat',
    'gün': 'gun', 'gun': 'gun', 'day': 'gun',
    'hafta': 'hafta', 'week': 'hafta',
}

const DEFAULT_TARGETS = {
    km: 'm', m: 'cm', cm: 'mm', mm: 'm',
    mi: 'km', ft: 'm', in: 'cm', yd: 'm',
    ton: 'kg', kg: 'g', g: 'mg', mg: 'g',
    lb: 'kg', oz: 'g',
    l: 'ml', ml: 'l', gal: 'l',
    c: 'f', f: 'c', k: 'c',
    byte: 'kb', kb: 'mb', mb: 'gb', gb: 'tb', tb: 'gb',
    sn: 'dk', dk: 'saat', saat: 'dk', gun: 'saat', hafta: 'gun',
}

export function parseUnitQuery(query) {
    if (!query || query.trim().length < 2) return null
    const q = query.trim().toLowerCase()

    const numMatch = q.match(/^([\d.,]+)\s*/)
    if (!numMatch) return null

    const amount = parseFloat(numMatch[1].replace(',', '.'))
    if (!amount || !isFinite(amount) || amount <= 0) return null

    const rest = q.slice(numMatch[0].length).trim()
    if (!rest) return null

    let fromText, toText = null
    const sepMatch = rest.match(/^(.+?)\s+(?:kaç|to|->|→|=)\s+(.+)$/)
    if (sepMatch) {
        fromText = sepMatch[1].trim()
        toText = sepMatch[2].trim()
    } else {
        fromText = rest
    }

    const fromUnit = UNIT_ALIASES[fromText]
    if (!fromUnit) return null

    let toUnit = null
    if (toText) {
        toUnit = UNIT_ALIASES[toText]
        if (!toUnit) return null
        if (UNITS[fromUnit].cat !== UNITS[toUnit].cat) return null
    } else {
        toUnit = DEFAULT_TARGETS[fromUnit] || null
    }

    if (!toUnit || fromUnit === toUnit) return null

    return { amount, from: fromUnit, to: toUnit }
}

export function convertUnit(amount, from, to) {
    const fromU = UNITS[from]
    const toU = UNITS[to]
    if (!fromU || !toU) return null

    if (fromU.cat === 'temp') {
        let celsius
        if (from === 'c') celsius = amount
        else if (from === 'f') celsius = (amount - 32) * 5 / 9
        else if (from === 'k') celsius = amount - 273.15
        else return null

        if (to === 'c') return celsius
        if (to === 'f') return celsius * 9 / 5 + 32
        if (to === 'k') return celsius + 273.15
        return null
    }

    return amount * fromU.factor / toU.factor
}
